<template>
  <!-- NOTE (TEMPLATE) to build a general proposal and use it in the project as a component -->
  <div class="animated fadeIn accelerator-requests" v-if="pageLoaded">
    <!-- loading component -->
    <Loading />
    <b-card style="border: 0" class="mt-0 mb-0">
      <h3>
        کد نشست تخصصی:
        {{ proposal.requestsCode }}
      </h3>
      <h4 class="text-dark">وضعیت نشست تخصصی: {{ proposal.status }}</h4>

      <hr />
      <v-btn
        class="float-end bc-purple text-capitalize"
        elevation="0"
        v-if="tabIndex == 0"
        variant="primary"
        @click="saveDocx('doc')"
      >
        <i class="fa fa-file-word-o white--text pe-1"></i>
        <span class="white--text"> دریافت Word</span>
      </v-btn>
      <b-tabs pills v-model="tabIndex">
        <!-- docx -->
        <div v-show="false" id="doc">
          <div class="all" style="text-align: right">
            <h1
              style="
                display: inline-block;
                text-align: center;
                padding: 5px 0;
                border-bottom: 3px solid black;
              "
            >
              کد نشست تخصصی:
              <span style="direction: ltr; font-family: Bahnschrift SemiBold">{{
                proposal.requestsCode
              }}</span>
            </h1>
            <div>
              <h2 style="color: black; direction: rtl">
                تاریخ خروجی: {{ exportDate }}
              </h2>
              <hr />
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                عنوان و حمایت‌های پیشین
              </h2>
              <div>
                <ul>
                  <li :class="proposal.faSubject ? 'done' : 'required'">
                    <strong>عنوان نشست: </strong>{{ proposal.faSubject }}
                  </li>
                  <li class="done">
                    <strong
                      >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده
                      کرده است؟
                    </strong>

                    {{ proposal.initialIsSupported ? "بله" : "خیر" }}
                  </li>

                  <li
                    v-if="
                      proposal.initialIsSupported &&
                      proposal.initialSupportedType != 'other'
                    "
                    :class="proposal.initialSupportedType ? 'done' : 'required'"
                  >
                    <strong> حمایت ها: </strong
                    >{{
                      hemayatOptions.filter(
                        (x) => x.value == proposal.initialSupportedType
                      )[0].text
                    }}
                  </li>
                  <li
                    v-if="
                      proposal.initialSupportedType == 'other' &&
                      proposal.initialIsSupported
                    "
                    :class="proposal.initialOtherSupport ? 'done' : 'required'"
                  >
                    <strong>عنوان حمایت دریافتی: </strong>
                    {{ proposal.initialOtherSupport }}
                  </li>
                  <li
                    v-if="proposal.initialIsSupported"
                    :class="
                      proposal.initialSupportDescription ? 'done' : 'required'
                    "
                  >
                    <strong>توضیحات حمایت دریافتی: </strong><br />
                    {{ proposal.initialSupportDescription }}
                  </li>
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="proposal.meetingSponsors"
                    :fields="sponsorFieldsDoc"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                </ul>
              </div>
            </div>
            <hr />
            <div>
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                اطلاعات اصلی دوره
              </h2>
              <div>
                <ul>
                  <li :class="proposal.faSubject ? 'done' : 'required'">
                    <strong>عنوان نشست تخصصی: </strong>{{ proposal.faSubject }}
                  </li>
                  <li :class="proposal.meetingGoals ? 'done' : 'required'">
                    <strong>هدف از برگزاری نشست: </strong><br />{{
                      proposal.meetingGoals
                    }}
                  </li>
                  <li :class="proposal.meetingPlace ? 'done' : 'required'">
                    <strong>مکان برگزاری نشست: </strong><br />{{
                      proposal.meetingPlace
                    }}
                  </li>
                  <li :class="proposal.universityId ? 'done' : 'required'">
                    <strong>دانشگاه محل برگزاری نشست: </strong>
                    {{
                      proposal.universityId
                        ? universities.filter(
                            (x) => x.id == proposal.universityId
                          )[0]
                          ? universities.filter(
                              (x) => x.id == proposal.universityId
                            )[0].text
                          : ""
                        : ""
                    }}
                  </li>
                  <li
                    v-if="proposal.universityId == notUniversity"
                    :class="proposal.otherUniversity ? 'done' : 'required'"
                  >
                    <strong>نام دانشگاه: </strong>{{ proposal.otherUniversity }}
                  </li>
                  <li
                    v-if="proposal.mehvarId != notMehvar"
                    :class="proposal.mehvarId ? 'done' : 'required'"
                  >
                    <strong>محور طرح: </strong>
                    {{ mehvarr }}
                  </li>
                  <li
                    v-if="proposal.mehvarId == notMehvar"
                    :class="proposal.mehvarId ? 'done' : 'required'"
                  >
                    <strong>محور طرح: </strong> سایر محورها
                  </li>
                  <li
                    v-if="proposal.mehvarId == notMehvar"
                    :class="proposal.otherMehvars ? 'done' : 'required'"
                  >
                    <strong>نام محور: </strong>{{ proposal.otherMehvars }}
                  </li>
                  <li>
                    <strong>حوزه طرح: </strong>
                    <ul>
                      <li v-if="proposal.zoneMedicine">پزشکی</li>
                      <li v-if="proposal.zoneAgriculture">کشاورزی</li>
                      <li v-if="proposal.zoneEnvironment">محیط زیست</li>
                      <li v-if="proposal.zoneIndustrial">صنعتی</li>
                      <li v-if="proposal.zoneBioComputing">رایانش زیستی</li>
                      <li v-if="proposal.zoneOther">سایر</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
            <hr />
            <div>
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                اطلاعات مجری برگزار کننده نشست
              </h2>
              <div>
                <ul>
                  <li :class="proposal.researcherName ? 'done' : 'required'">
                    <strong>نام: </strong>{{ proposal.researcherName }}
                  </li>
                  <li
                    :class="proposal.researcherLastName ? 'done' : 'required'"
                  >
                    <strong>نام خانوادگی: </strong
                    >{{ proposal.researcherLastName }}
                  </li>
                  <li :class="proposal.researcherNatCode ? 'done' : 'required'">
                    <strong>کدملی: </strong>{{ proposal.researcherNatCode }}
                  </li>
                  <li :class="proposal.researcherMobile ? 'done' : 'required'">
                    <strong>تلفن همراه: </strong>{{ proposal.researcherMobile }}
                  </li>
                  <li :class="proposal.researcherFax ? 'done' : 'required'">
                    <strong>دورنگار: </strong>{{ proposal.researcherFax }}
                  </li>
                  <li :class="proposal.researcherEmail ? 'done' : 'required'">
                    <strong>پست الکترونیکی: </strong
                    >{{ proposal.researcherEmail }}
                  </li>
                  <li :class="proposal.researcherState ? 'done' : 'required'">
                    <strong>استان: </strong>{{ proposal.researcherState }}
                  </li>
                  <li :class="proposal.researcherCity ? 'done' : 'required'">
                    <strong>شهر: </strong>{{ proposal.researcherCity }}
                  </li>
                  <li
                    :class="
                      proposal.researcherUniversityId ? 'done' : 'required'
                    "
                  >
                    <strong>دانشگاه محل تحصیل: </strong>
                    {{
                      proposal.researcherUniversityId
                        ? universities.filter(
                            (x) => x.id == proposal.researcherUniversityId
                          )[0]
                          ? universities.filter(
                              (x) => x.id == proposal.researcherUniversityId
                            )[0].text
                          : "-"
                        : "-"
                    }}
                  </li>
                  <li
                    :class="
                      proposal.researcherUniversityOther ? 'done' : 'required'
                    "
                    v-if="proposal.researcherUniversityId == notUniversity"
                  >
                    <strong>نام دانشگاه: </strong
                    >{{ proposal.researcherUniversityOther }}
                  </li>
                  <li>
                    <strong>دانشگاه محل اشتغال به عنوان عضوهئیت علمی: </strong>
                    {{
                      proposal.researcherUniversityJobId
                        ? universities.filter(
                            (x) => x.id == proposal.researcherUniversityJobId
                          )[0]
                          ? universities.filter(
                              (x) => x.id == proposal.researcherUniversityJobId
                            )[0].text
                          : "-"
                        : "-"
                    }}
                  </li>
                  <li
                    v-if="proposal.researcherUniversityJobId == notUniversity"
                  >
                    نام دانشگاه: {{ proposal.researcherUniversityJobOther }}
                  </li>
                  <li
                    :class="proposal.researcherLastDegree ? 'done' : 'required'"
                  >
                    <strong>آخرین مدرک تحصیلی: </strong
                    >{{ proposal.researcherLastDegree }}
                  </li>
                  <li>
                    <strong style="color: blue"
                      >نشست های تخصصی برگزار شده:
                    </strong>

                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="proposal.researcherMeetings"
                      :fields="meetingFieldsDoc"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                  </li>
                  <li>
                    <strong style="color: blue">کارگاه های برگزار شده: </strong>

                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="proposal.researcherWorkshops"
                      :fields="workshopFieldsDoc"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                  </li>
                </ul>
              </div>
            </div>
            <hr />
            <div>
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                برگزار کنندگان
              </h2>

              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.colleagues"
                :fields="organizersFieldsDoc"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
              </b-table>
            </div>
            <hr />
            <div>
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                زمان‌بندی
              </h2>
              <div>
                <strong>زمان شروع: </strong>
                {{
                  proposal.gantData.length > 0
                    ? moment(
                        new Date(
                          Math.min(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.startDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          )
                        )
                      ).format("jDD/jMM/jYYYY")
                    : ""
                }}
                <br />
                <strong>زمان پایان: </strong>
                {{
                  proposal.gantData.length > 0
                    ? moment(
                        new Date(
                          Math.max(
                            ...proposal.gantData.map((x) =>
                              new Date(
                                moment(x.dueDate, "jYYYY/jMM/jDD").format(
                                  "YYYY-MM-DD"
                                )
                              ).getTime()
                            )
                          )
                        )
                      ).format("jDD/jMM/jYYYY")
                    : ""
                }}
                <br />
                <strong>مدت زمان: </strong>
                {{
                  proposal.gantData.length > 0
                    ? (Math.max(
                        ...proposal.gantData.map((x) =>
                          new Date(
                            moment(x.dueDate, "jYYYY/jMM/jDD").format(
                              "YYYY-MM-DD"
                            )
                          ).getTime()
                        )
                      ) -
                        Math.min(
                          ...proposal.gantData.map((x) =>
                            new Date(
                              moment(x.startDate, "jYYYY/jMM/jDD").format(
                                "YYYY-MM-DD"
                              )
                            ).getTime()
                          )
                        )) /
                        3600 /
                        24 /
                        1000 +
                      " روز"
                    : ""
                }}
                <br />
              </div>
              <b-table
                responsive
                small
                show-empty
                head-variant="dark"
                :items="proposal.gantData"
                :fields="serviceFieldsDoc"
                empty-text="رکوردی برای نمایش وجود ندارد"
                class="table table-secondary"
              >
                <template v-slot:head()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.label }}
                  </div>
                </template>
                <template v-slot:cell()="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.value }}
                  </div>
                </template>
                <template v-slot:cell(index)="data">
                  <div style="text-align: center; vertical-align: middle">
                    {{ data.index + 1 }}
                  </div>
                </template>
              </b-table>
            </div>
            <hr />
            <div>
              <h2
                style="display: inline-block; text-align: center; color: blue"
              >
                تعهدات
              </h2>
              <div>
                <ul>
                  <li v-if="proposal.promiseArrays[0]">
                    با توجه به آیین نامه تمامی مستندات در پایان نشست در سامانه
                    بارگذاری خواهد شد.
                  </li>
                  <li v-if="proposal.promiseArrays[1]">
                    گزارش برگزاری نشست طی 24 ساعت جهت درج در سایت ستاد ارائه می
                    شود.
                  </li>
                  <li v-if="proposal.promiseArrays[2]">
                    عکس های برگزاری نشست طی 24 ساعت جهت درج در سایت ستاد ارائه
                    می شود می‌باشد.
                  </li>
                  <li v-if="proposal.promiseArrays[3]">
                    پوستر نشست قبل از چاپ به تایید گروه پژوهش خواهد رسید.
                  </li>
                  <li v-if="proposal.promiseArrays[4]">
                    متن خبر پیش از برگزاری جهت درج در سایت به همراه پوستر تایید
                    شده به گروه پژوهش ارسال می شود.
                  </li>
                  <li v-if="proposal.promiseArrays[5]">
                    هماهنگی مناسب با ناظر نشست صورت خواهد گرفت.
                  </li>
                  <li v-if="proposal.promiseArrays[6]">
                    پذیرایی از شرکت کنندگان طبق آیین نامه صورت خواهد گرفت.
                  </li>
                  <li v-if="proposal.promiseArrays[7]">
                    گواهی نامه ها طبق آیین نامه و با هماهنگی گروه پژوهش تهیه و
                    در اختیار شرکت کنندگان قرار می گیرد.
                  </li>
                  <li v-if="proposal.promiseArrays[8]">
                    لینک اخبار و مستندات و گزارش ها روی سامانه بارگذاری خواهد
                    شد.
                  </li>
                  <li v-if="proposal.promiseArrays[9]">
                    کتابچه برگزاری نشست با هماهنگی گروه پژوهش تهیه و در اختیار
                    ستاد قرار می گیرد.
                  </li>
                </ul>
              </div>
            </div>
            <hr />
          </div>
        </div>
        <!-- docx -->
        <b-tab title="چکیده طرح" lazy>
          <Meeting
            :proposal="proposal"
            :universities="universities"
            :mehvars="mehvars"
            :isLoaded="isLoaded"
          />
        </b-tab>
        <b-tab title="فایل های تکمیلی">
          <Files :files="proposal.uploadedFiles" :isLoaded="isLoaded" />
        </b-tab>
        <!-- Project Control part -->
        <b-tab title="کنترل پروژه" active>
          <accelerator-pc
            :acceleratorReport="acceleratorReport"
            :reportFiles="reportFiles"
          ></accelerator-pc>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
const sarmadGantt = () => import("./../../components/sarmadGantt");
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import AcceleratorPc from "../../components/AcceleratorPc.vue";
import Meeting from "./../../components/AcceleratorMeeting";
import Files from "./../../components/UploadedFiles";
export default {
  props: ["role"],
  components: {
    datePicker: VuePersianDatetimePicker,
    sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
    Select2, // NOTE (COMPONENT) component of select2 plugin
    AcceleratorPc,
    Meeting,
    Files,
  },
  data() {
    return {
      reports: [],
      reports2: [],
      pageLoaded: false,
      resFileBusy: false,
      editClick: false,
      tableBusy: false,

      refFiles: [],
      acceleratorReport: {},

      tabIndex: 3,
      newReportBusy: false,

      max: 100,
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "showName", label: "نام فایل" },
        { key: "title", label: "عنوان فایل" },
        { key: "url", label: "دریافت" },
      ],

      projectControl: [],
      hemayatOptions: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
      moment: moment,
      show: false,
      busy: false,
      fileBusy: false,
      acc: 0,
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
      proposal: {},

      universities: [],
      otherUniversity: "",
      mehvars: [],
      otherMehvars: "",
      dateFrom: moment(new Date()).format("jYYYY/jMM/jDD"),
      dateTo: moment(new Date()).format("jYYYY/jMM/jDD"),
      zone: new Array(6).fill(false),
      achievmentitems: [],
      proposalStudies: false,
      proposalDevelopment: false,
      proposalPractical: false,
      drPosition: ["مربی", "استادیار", "دانشیار", "استاد‌تمام"],
      committieType: ["وزارت علوم", "وزارت بهداشت"],
      lastDegree: ["کارشناسی", "کارشناسی ارشد", "دکتری"],
      support: "",
      supportSetad: "",
      dr: {},
      selectedMehvar: 0,
      taahol: "",
      isLoaded: true,
      DoiItem: [],
      inputs: [
        {
          name: "",
        },
      ],
      DoiField: [
        { key: "subject", label: "عنوان" },
        { key: "mag", label: "مجله" },
        { key: "if", label: "IF" },
        { key: "year", label: "سال" },
      ],
      inventionItem: [],
      inventionField: [
        { key: "subject", label: "عنوان" },
        { key: "year", label: "سال" },
        { key: "description", label: "توضیحات" },
      ],
      sponsorFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام حامی" },
        { key: "operation", label: "" },
      ],
      sponsorFieldsDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام حامی" },
      ],
      file: null,
      fileFilter: "",
      OrgCostItem: [],
      OrgCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود).",
        },
        { key: "totalPrice", label: "هزینه (ریال)" },
        { key: "operation", label: "" },
      ],
      OrgCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود).",
        },
        { key: "totalPrice", label: "هزینه (ریال)" },
      ],
      deviceCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        { key: "consumable", label: "مصرفی" },
        { key: "fund", label: "سرمایه‌ای" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد" },
        { key: "perPrice", label: "قیمت واحد به ریال" },
        { key: "totalPrice", label: "قیمت کل به ریال" },
        { key: "operation", label: "" },
      ],
      deviceCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        { key: "consumable", label: "مصرفی" },
        { key: "fund", label: "سرمایه‌ای" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد" },
        { key: "perPrice", label: "قیمت واحد به ریال" },
        { key: "totalPrice", label: "قیمت کل به ریال" },
      ],

      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "amount", label: "کمی شده دستاورد و خروجی" },
        { key: "fullfill", label: "پیش بینی زمان تحقق دستاورد و خروجی (ماه)" },
        { key: "operation", label: "" },
      ],
      achievmentFieldsDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "amount", label: "کمی شده دستاورد و خروجی" },
        { key: "fullfill", label: "پیش بینی زمان تحقق دستاورد و خروجی (ماه)" },
      ],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      serviceFieldsDoc: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
      ],
      tripCostField: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه (ریال)" },
        { key: "operation", label: "" },
      ],
      tripCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه (ریال)" },
      ],
      meetingFields: [
        { key: "index", label: "ردیف" },
        { key: "meetingSubject", label: "عنوان نشست" },
        { key: "meetingPlace", label: "محل برگزاری" },
        { key: "meetingDate", label: "تاریخ برگزاری" },
        { key: "supporterOrg", label: "سازمان حمایت کننده" },
        { key: "operation", label: "" },
      ],
      meetingFieldsDoc: [
        { key: "index", label: "ردیف" },
        { key: "meetingSubject", label: "عنوان نشست" },
        { key: "meetingPlace", label: "محل برگزاری" },
        { key: "meetingDate", label: "تاریخ برگزاری" },
        { key: "supporterOrg", label: "سازمان حمایت کننده" },
      ],
      workshopFields: [
        { key: "index", label: "ردیف" },
        { key: "workshopSubject", label: "عنوان کارگاه برگزار شده" },
        { key: "workshopPlace", label: "محل برگزاری" },
        { key: "workshopDate", label: "تاریخ برگزاری" },
        { key: "workshopSupporterOrg", label: "سازمان حمایت کننده" },
        { key: "operation", label: "" },
      ],
      workshopFieldsDoc: [
        { key: "index", label: "ردیف" },
        { key: "workshopSubject", label: "عنوان کارگاه برگزار شده" },
        { key: "workshopPlace", label: "محل برگزاری" },
        { key: "workshopDate", label: "تاریخ برگزاری" },
        { key: "workshopSupporterOrg", label: "سازمان حمایت کننده" },
      ],
      organizersFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "lastName", label: "نام خانوادگی" },
        { key: "cooperationType", label: "نوع همکاری" },
        { key: "position", label: "سمت" },
        { key: "mobile", label: "شماره تماس" },
        { key: "email", label: "ایمیل" },
        { key: "operation", label: "" },
      ],
      organizersFieldsDoc: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "lastName", label: "نام خانوادگی" },
        { key: "cooperationType", label: "نوع همکاری" },
        { key: "position", label: "سمت" },
        { key: "mobile", label: "شماره تماس" },
        { key: "email", label: "ایمیل" },
      ],
      config: {
        locale: {
          name: "en",
        },
        height: 50,
        list: {
          rows: {},
          columns: {
            data: {
              id: {
                id: "id",
                data: "id",
                width: 50,
                header: {
                  content: "ردیف",
                },
              },
              label: {
                id: "label",
                data: "label",
                width: 200,
                header: {
                  content: "نام فعالیت",
                },
              },
              start: {
                id: "start",
                data: (start) => moment(start).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ آغاز",
                },
              },
              end: {
                id: "end",
                data: (end) => moment(end).format("jYYYY/jMM/jDD"),

                width: 200,
                header: {
                  content: "تاریخ پایان",
                },
              },
            },
          },
        },
        chart: {
          time: {
            zoom: 12,
          },
          items: {},
        },
      },
      background: [
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
        "#bd965c",
        "#66b36c",
        "#4a98eb",
        "#91df9a",
        "#af50cd",
        "#4b8854",
        "#2b3699",
        "#b8f3f7",
        "#47bb5a",
        "#4b729e",
        "#0b83f5",
        "#c014f2",
        "#4e4c30",
        "#372f6c",
      ],
      addFile: {
        fileName: "",
        fileDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      },
      otherFiles: new Array(10).fill({
        isUploaded: false,
      }),
      newReportSubject: "",
      newReportDate: "",
      pcUploadedFiles: [],
      contractName: "",
      resReportFiles: [],
      reportFiles: [],
      contractUrl: "",
      uploadedContract: false,
      reportFile: [],
      reportFinanceFile: [],
      myPcFile: [],
      resContractFile: [],
    };
  },
  computed: {
    mehvarr() {
      let mehvarr;
      try {
        mehvarr = this.mehvars.filter((x) => x.id == this.proposal.mehvarId)[0]
          .text;
      } catch (error) {
        mehvarr = "";
      }
      return mehvarr;
    },
  },
  methods: {
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.proposal.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    showProject() {
      this.proposal = {
        adminMessage: "",
        meetingGoals: "هدف تستی",
        meetingPlace: "مکان تستی",
        startDate: "1401/02/20",
        finalDate: "1401/02/21",
        meetingSponsors: [{ name: "مهیار احمدپور" }],
        certificateSupervisorFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987819432Abstract-hd-wallpapers-1080p.jpg",
        certificateSupervisorFileId: "6277556be3c2e22524009114",
        companyContactInfo: "آدرس",
        companyDescription: "توضیحات",
        companyId: "61d1a695cc60c901580c6151",
        companyName: "معروفی",
        companyNationalId: "0019936982",
        companyProducts: "معرفی",
        companyRegistrationNumber: "44456",
        comprehensiveTestFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987775573ppk-pms-v2.pdf",
        comprehensiveTestFileId: "6277553fe3c2e225240090a2",
        enSubject: "parnia opportunity test",
        faSubject: "فرصت تستی پرنیا",
        fastSub: false,
        foreignTeacherResumeFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987762032drugApp.pdf",
        researcherMeetings: [
          {
            meetingDate: "1401/02/18",
            meetingPlace: "محل 1",
            meetingSubject: "عنوان 1",
            supporterOrg: "سازمان 1",
          },
        ],
        researcherWorkshops: [
          {
            workshopDate: "1401/02/14",
            workshopPlace: "محل 3",
            workshopSubject: "عنوان 3",
            workshopSupporterOrg: "سازمان 3",
          },
        ],
        gantData: [
          {
            cellColor: "#D33115",
            description: "فعالیت تستی",
            dueDate: "1401/02/19",
            percent: "100",
            startDate: "1400/12/01",
          },
        ],
        hindexFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987768763vueRouter-query.docx",
        hindexFileId: "62775538e3c2e2252400908f",
        history: [
          {
            date: "1401/02/18",
            message:
              'وضعیت درخواست "فرصت مطالعاتی" توسط "ناصری" به "تایید نهایی" تغییر داده شد./توضیحات: "تست"',
            name: "ناصری",
            timeStamp: "1651988557",
          },
        ],
        initialIsSupported: true,
        initialObligation: true,
        initialOtherSupport: "حمایت سایر تستی",
        initialSupportDescription:
          "توضیحات برای سایر تستی به عنوان حمایت دریافت شده!",
        initialSupportedType: "other",
        invitationDestinationCountryFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987791578drugApp.pdf",
        invitationDestinationCountryFileId: "6277554fe3c2e225240090db",
        isArchive: false,
        lastUpdated: "",
        letterCompanyFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987831091164182244320415212c298b7e816e7fc10a235110f047.jpg",
        letterCompanyFileId: "62775577e3c2e2252400913a",
        letterRequestDeputyResearchFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987825068Abstract-hd-wallpapers-1080p.jpg",
        letterRequestDeputyResearchFileId: "62775571e3c2e22524009127",
        mehvarId: "1",
        minutesDefenceFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987781520drugApp.pdf",
        minutesDefenceFileId: "62775545e3c2e225240090b5",
        onWayTicketFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987800541@Wallpaper_4K3D (5475).jpg",
        onWayTicketFileId: "62775559e3c2e225240090ee",
        oppurtunityAchievements: [
          { name: "دستاورد تستی 1" },
          { name: "دستاورد تستی 2" },
        ],
        oppurtunityActions: "خلاصه ای از اقدامات تستی",
        otherCompanyName: "",
        otherCompanyNationalId: "",
        otherCompanyRegistrationNumber: "",
        otherFile1:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987838218programing.jpg",
        otherFile1Description: "",
        otherFile1Id: "6277557ee3c2e2252400914d",
        otherFile1Title: "سایر مدارک تستی",
        otherFile2: "",
        otherFile2Description: "",
        otherFile2Id: "",
        otherFile2Title: "",
        otherFile3: "",
        otherFile3Description: "",
        otherFile3Id: "",
        otherFile3Title: "",
        otherMehvars: "محور تستی دانشگاه تهران مرکز",
        otherUniversity: "تهران مرکز",
        promiseArrays: [
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
          true,
        ],
        proposalWordFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987786858customizing color.docx",
        proposalWordFileId: "6277554ae3c2e225240090c8",
        registerDate: "1401/02/18",
        rejectionIds: [],
        requestsCode: "biodc-2002154-2002238.1",
        researcherArticleISI: [
          {
            file: {
              isUploaded: true,
              showProgress: true,
              striped: false,
              uploadButDisable: false,
              uploadPercentage: 100,
              variant: "success",
            },
            uploadedFile: {
              id: "62774e33e3c2e22524008e53",
              showName: "git-flow.pdf",
              url: "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651985971155git-flow.pdf",
            },
            magName: "تست",
            refrence: "2",
            releaseYear: "1399",
            subject: "عنوان 1",
            writersName: "آرینا شهبازی",
          },
        ],
        researcherBankName: "ملت",
        researcherCity: "تهران",
        researcherComprehensiveTestDate: "1401/02/17",
        researcherComprehensiveTestMark: "20",
        researcherCountryDestination: "ژاپن",
        researcherEmail: "parniamaroofi@gmail.com",
        researcherFax: "4455",
        researcherHindex: "2",
        researcherIBAN: "1484520",
        researcherLastName: "معروفی",
        researcherMasterStudent: "student",
        researcherMobile: "09226907483",
        researcherName: "پرنیا",
        researcherNatCode: "0019936982",
        researcherPhDThesisDefenceDate: "1401/02/18",
        researcherPhDThesisSubject: "عنوان تستی",
        researcherResumeFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987736500customizing-color.pdf",
        researcherResumeFileId: "62775518e3c2e22524009069",
        researcherState: "تهران",
        researcherUniversityDestination: "بین المللی",
        researcherUniversityId: "61540047099e14274252ea5e",
        researcherUniversityJobId: "1",
        researcherUniversityJobOther: "دانشگاه تستی",
        researcherUniversityOther: "",
        returnTicketFile: "",
        returnTicketFileId: "",
        revision: "1",
        status: "تایید نهایی",
        colleagues: [
          {
            email: "a@aa.aa",
            id: "62775609e3c2e225240091a1",
            lastDegree: "دکتری",
            lastName: "ناصری",
            mobile: "09191161279",
            name: "امیرمسعود",
            natCode: "11111111111",
            position: "سمت تستی",
            cooperationType: "تست",
            resumeFile:
              "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651986063220vueRouter-query.docx",
            resumeFileId: "62774e8fe3c2e22524008e8c",
            resumeFileName: "vueRouter-query.docx",
            universityId: "61540047099e14274252ea5e",
            universityJobId: "61540047099e14274252ea66",
            universityJobOther: "",
            universityOther: "",
          },
        ],
        typePractical: false,
        typeStudy: true,
        typeSystemicDevelopmental: false,
        universityId: "1",
        uploadedFiles: [
          {
            id: "62775518e3c2e22524009069",
            showName: "customizing-color.pdf",
            title: "رزومه متقاضی",
            url: "undefined/setad/private/project\\6278b5aeca3537165c6ebbf3\\1652078306474customizing-color.pdf",
          },
          {
            id: "62775518e3c2e22524009069",
            showName: "customizing-color.pdf",
            title: "رزومه متقاضی",
            url: "undefined/setad/private/project\\6278b5aeca3537165c6ebbf3\\1652078306474customizing-color.pdf",
          },
          {
            id: "62775518e3c2e22524009069",
            showName: "customizing-color.pdf",
            title: "رزومه متقاضی",
            url: "undefined/setad/private/project\\6278b5aeca3537165c6ebbf3\\1652078306474customizing-color.pdf",
          },
          {
            id: "62775518e3c2e22524009069",
            showName: "customizing-color.pdf",
            title: "رزومه متقاضی",
            url: "undefined/setad/private/project\\6278b5aeca3537165c6ebbf3\\1652078306474customizing-color.pdf",
          },
        ],
        visaFile:
          "undefined/setad/private/opportune\\62774d14e3c2e22524008de3\\1651987809735@Wallpaper_4K3D (9371).jpg",
        visaFileId: "62775566e3c2e22524009101",
        zoneAgriculture: false,
        zoneBioComputing: false,
        zoneEnvironment: false,
        zoneIndustrial: false,
        zoneMedicine: true,
        zoneOther: true,
      };

      this.acceleratorReport = {
        subject: "کنترل پروژه نشست تخصصی شتاب‌دهنده",
        percent: 45,
        description: "wow",
        judgeDescription: "",
        judgePercent: "",
        file: "undefined/setad/private/project\\627206f87e34663cdc6fb630\\16516405901522431b5bb0a466ed58020ceea3f4e070e.jpg",
        financeFile:
          "undefined/setad/private/project\\627206f87e34663cdc6fb630\\1651641592714164182244320415212c298b7e816e7fc10a235110f047.jpg",
      };

      this.reportFiles.push({
        name: "گزارش",
        url: this.acceleratorReport.file,
      }),
        this.acceleratorReport.financeFile
          ? this.reportFiles.push({
              name: "درخواست مالی",
              url: this.acceleratorReport.financeFile,
            })
          : "";

      setTimeout(() => {
        this.pageLoaded = true;
        this.show = true;
        this.fileBusy = false;
      }, 200);

      //  this.$http
      //    .post(
      //      this.baseUrl + "/setad/reviewer/report/meeting/getInfo",
      //      {
      //        reportId: this.$route.params.id,
      //      },
      //      {
      //        headers: {
      //          Authorization: "Bearer: " + localStorage.getItem("userId"),
      //        },
      //      }
      //    )
      //    .then((res) => {
      //      this.proposal = res.data.request;
      //      this.reviewerData = this.proposal.reviewers;
      //      this.acceleratorReport = res.data.report;
      //      this.teachers = res.data.proposal.teachers;
      //      this.acceleratorReport.judge = "";
      //      this.acceleratorReport.judgePercent = "";
      //      this.acceleratorReport.judgeDescription = "";

      //      this.reportFiles.push({
      //        name: "گزارش",
      //        url: this.acceleratorReport.file,
      //      }),
      //        this.acceleratorReport.financeFile
      //          ? this.reportFiles.push({
      //              name: "درخواست مالی",
      //              url: this.acceleratorReport.financeFile,
      //            })
      //          : "",
      //        (this.show = false);

      //      this.acc++;

      //      if (this.acc > 2) {
      //        this.$bvModal.hide("loading");
      //        this.isLoaded = true;
      //      }
      //      setTimeout(() => {
      //        // NOTE (m-setTimeout) to set timeout for 200 ms
      //        this.pageLoaded = true;
      //        this.show = true;
      //      }, 200);

      //      this.fileBusy = false;
      //    })
      //    .catch((err) => {
      //      this.$bvModal.hide("loading");
      //      this.isLoaded = true;
      //      console.log(err)
      //      this.$router.push("/referee/projectsControl");
      //    });
    },
    onMounted() {
      // NOTE (MOUNTED) to show the data of this page
      //  this.$bvModal.show("loading");
      //  this.isLoaded = false;
      //  this.$root.$emit("show::modal", "loading");
      //  this.busyAll = true;
      //  let allUniMehvars = this.$http.post(
      //    this.baseUrl + "/setad/options/uniMehvars",
      //    {},
      //    {
      //      headers: {
      //        Authorization: "Bearer: " + localStorage.getItem("userId"),
      //      },
      //    }
      //  );
      //  let allUniversities = this.$http.post(
      //    this.baseUrl + "/setad/options/universities",
      //    {},
      //    {
      //      headers: {
      //        Authorization: "Bearer: " + localStorage.getItem("userId"),
      //      },
      //    }
      //  );
      //  Promise.all([allUniMehvars, allUniversities]).then((res) => {
      //    let allMehv = res[0].data;
      //    let allUni = res[1].data;
      //    this.acc++;
      //    this.progressValue += 30;
      //    if (this.acc > 2) {
      //      this.$bvModal.hide("loading");
      //      this.isLoaded = true;
      //      this.busyAll = false;
      //    }
      //    this.mehvars = allMehv;
      //    this.mehvars.push(
      //      new Object({
      //        id: 1,
      //        text: "سایر محورها",
      //        universityId: 1,
      //      })
      //    );
      //    this.acc++;
      //    this.progressValue += 30;
      //    if (this.acc > 2) {
      //      this.$bvModal.hide("loading");
      //      this.isLoaded = true;
      //      this.busyAll = false;
      //    }
      //    this.universities = allUni;
      //    this.universities.push(
      //      new Object({
      //        id: 1,
      //        text: "سایر دانشگاه‌ها",
      //      })
      //    );
      //  });
      //  this.fileBusy = false;
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
    this.showProject();
    this.onMounted();
  },
};
</script>
<style scoped lang="scss">
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.select2 {
  width: 100% !important;
}

select {
  min-width: max-content;
  width: 100%;
}

.required {
  color: red;
}

.done {
  color: green;
}
.btn-dark {
  color: #fff !important;
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  color: #fff !important;
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  color: #fff !important;
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  color: #fff !important;
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  color: #fff !important;
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}

.contract-section {
  .custom-control-inline {
    margin-right: 0 !important;
  }
}

.diabled-textarea {
  color: grey;
  border-radius: 6px;
  padding: 8px 12px;
  width: 100%;
  min-height: 45px;
  position: relative;
  padding-top: 10px;
  background-color: #e4e7ea;
}
</style>
<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
#forceFinishedModal___BV_modal_header_ {
  button {
    margin: -1rem !important;
  }
}
</style>
